import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundImage extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Image",
    component: inspectorTools.MEDIA_PICKER,
    props: {
      mediaType: "image",
    },
  };

  static defaultValue = "";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "none") {
      return "";
    }
    return configValue;
  }
}
